<template>
  <div class="footer-box">
    <div v-if="!hiddenContact" class="contact-box">
      <img :src="contactBg" alt="" />
      <div class="box">
        <p class="title">Contact Us</p>
        <p class="txt">ご注文・ご質問は、下記の電話、FAX、メールにて承ります。
          <br />担当者より3営業日以内に連絡いたします。</p>
        <div class="rows">
          <p class="row">
          <span class="img">
            <img :src="iconTel" alt="" />
          </span>
            <span class="value">{{curInfo.tel}}</span>
          </p>
          <p class="row">
          <span class="img">
            <img :src="iconFax" alt="" />
          </span>
            <span class="value">{{curInfo.fax}}</span>
          </p>
          <p class="row">
          <span class="img">
            <img :src="iconEmail" alt="" />
          </span>
            <span class="value">{{curInfo.email}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="footer-menu">
      <div class="left">
        <p class="logo">
          <img :src="footLogo" alt="" />
        </p>
        <p class="address">{{curInfo.zip_code}}<br />
          <span v-html="curInfo.address"></span>
          </p>
        <p class="tel-box">
          TEL:{{curInfo.tel}}<br />
          FAX:{{curInfo.fax}}<br />
          E-MAIL:{{curInfo.email}}
        </p>

        <!-- <p class="title">デルのビジネス</p> -->
        <div class="menu-rows">
          <p
            v-for="(item, index) in menus"
            class="row"
            :style="item.style"
            :class="{active: item.key === curSelect}"
            :key="index"
            @click="handleClick(item)"
          >
            <span class="name">{{item.value}}</span>
            <!--<span class="line"></span>-->
          </p>
        </div>
        <p class="word">© 双華株式会社</p>
      </div>
      <div class="right">
        <div class="title-box">
          <p class="title">関連製品</p>
          <!--<p class="btns">-->
            <!--<span class="angle">←</span>-->
            <!--<span class="angle active">→</span>-->
          <!--</p>-->
        </div>
        <div class="product-box">
          <swiper2
            navigation
            :slidesPerView="2"
            :list.sync="productData"
          />
          <!--<p-->
            <!--v-for="(item, index) in productData"-->
            <!--class="item"-->
            <!--:key="index"-->
          <!--&gt;-->
            <!--<span class="img"><img :src="item" alt=""></span>-->
          <!--</p>-->
        </div>

        <p class="line-box">
          <span class="line"></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import swiper2 from '../../components/swiperBox2'
import { comm } from '../../api/home'

export default {
  name: 'index',
  components: {
    swiper2
  },
  props: {
    // 隐藏联系我们
    hiddenContact: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const {
      home: {
        contact_bg: contactBg,
        icon_tel: iconTel,
        icon_fax: iconFax,
        icon_email: iconEmail,
        footLogo,
        product_1: product1,
        product_2: product2,
        product_3: product3,
        product_4: product4,
        product_5: product5,
        product_6: product6,
        product_7: product7
      }
    } = this.$images
    return {
      curInfo: {}, // 当前信息
      curSelect: '/',
      menus: [
        { key: '/summary', value: '会社概要' },
        { key: '/culture', value: '企業沿革' },
        { key: '/content', value: '事業内容' },
        { key: '/product', value: '取扱商品' },
        { key: '/future', value: '今後の展望', style: 'margin-right: 90px;' },
        { key: '/contact', value: 'お問合せ' }
      ],
      productData: [
        { id: 1, url: product1 },
        { id: 2, url: product2 },
        { id: 3, url: product3 },
        { id: 4, url: product4 },
        { id: 5, url: product5 },
        { id: 6, url: product6 },
        { id: 7, url: product7 }
      ],
      contactBg,
      iconTel,
      iconFax,
      iconEmail,
      footLogo
    }
  },
  created () {
    this.init()
  },
  mounted () {
    const fn = setTimeout(() => {
      this.curSelect = this.$route.path
      this.$emit('onSelect', this.curSelect)
      clearTimeout(fn)
    }, 200)
  },
  methods: {
    init () {
      this.getInfo()
    },
    async getInfo () {
      const res = await comm()
      const { data } = res
      console.log('getInfo==>', data)
      this.curInfo = data
    },
    handleClick (item) {
      const { key } = item
      this.curSelect = key
      this.$emit('onSelect', this.curSelect)
      this.$router.push({ path: key })
    }
  }
}
</script>

<style lang="less" scoped>
.footer-box{
  display: flex;
  flex-direction: column;

  .contact-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1920px;
    height: 695px;
    background: #025999;
    position: relative;

    .box {
      position: absolute;
      top: 0px;
      left: 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;

      .title {
        height: 55px;
        font-family: Arial;
        font-weight: bold;
        font-size: 72px;
        color: #FFFFFF;
        line-height: 55px;
        margin-top: 148px;
      }

      .txt {
        height: 57px;
        font-family: 04 KanjyukuGothic;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 38px;
        margin-top: 38px;
      }

      .rows {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 45px;

        .row {
          width: 482px;
          height: 217px;
          display: flex;
          flex-direction: column;
          align-items: center;

          &:nth-child(2) {
            border-left: 1px solid white;
            border-right: 1px solid white;
          }

          .img {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 53px;
            height: 53px;
            /*background-color: wheat;*/
            margin-top: 27px;
          }

          .value {
            height: 36px;
            font-family: Arial;
            font-weight: 400;
            font-size: 48px;
            color: #FFFFFF;
            line-height: 36px;
            margin-top: 81px;
          }
        }
      }
    }
  }

  .footer-menu{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .left{
      margin-left: 274px;
      width: 514px;

      .logo{
        width: 256px;
        height: 62px;
        margin-top: 52px;
        /*background-color: wheat;*/
      }
      .address{
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        line-height: 30px;
        margin-top: 40px;
        width: 266px;
      }
      .tel-box{
        font-family: HarmonyOS_Sans_SC;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        line-height: 32px;
        margin-top: 10px;
      }
      .title{
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        line-height: 22px;
        margin-top: 28px;
      }
      .menu-rows{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-top: 21px;

        .row{
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          line-height: 42px;
          margin-right: 111px;
          position: relative;
          cursor: pointer;

          &:active, &:hover {
            outline-width: 0;
          }

          &:hover{
            .name{
              background-size: 100% 2px;
              background-position: 0 100%;
            }
          }

          .name{
            background-image: linear-gradient(#222, #222);
            background-size: 0 2px;
            background-repeat: no-repeat;
            background-position: 100% 100%;
            transition: background-size .3s cubic-bezier(.33,1,.68,1);
            line-height: 40px;
            display: inline-block;
          }

          &.active{
            color: #374475;
            pointer-events: none;
          }
        }
      }
      .word{
        font-family: Alibaba;
        font-weight: normal;
        font-size: 22px;
        color: #999999;
        line-height: 22px;
        margin-top: 34px;
        margin-bottom: 70px;
      }
    }

    .right{
      margin-top: 146px;
      width: 851px;
      overflow: hidden;
      position: relative;

      .title-box{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 851px;
        height: 47px;

        .title{
          font-weight: 400;
          font-size: 22px;
          color: #333333;
          line-height: 22px;
        }
        .btns{
          display: flex;
          flex-direction: row;

          .angle{
            width: 41px;
            height: 41px;
            line-height: 41px;
            text-align: center;
            margin-left: 9px;
            background: #FFFFFF;
            border-radius: 50%;
            border: 3px solid rgba(2,89,53, .3);
            font-size: 24px;
            font-weight: bold;
            color: rgba(2,89,53, .3);
            user-select: none;

            &.active{
              border: 3px solid #374475;
              color: #374475;
              cursor: pointer;
            }
          }
        }
      }

      .product-box{
        display: flex;
        flex-direction: row;
        margin-top: 28px;
        overflow: hidden;

        .item{
          width: 417px;
          height: 273px;
          background: #F8FCFF;
          margin-right: 30px;
          flex-shrink: 0;
          /*background-color: wheat;*/
        }
      }

      .line-box{
        width: 861px;
        height: 3px;
        background: #E4E4E4;
        margin-top: 72px;
        position: relative;

        .line{
          position: absolute;
          top: 0px;
          left: 0px;
          display: inline-block;
          width: 417px;
          height: 3px;
          background: #374475;
        }
      }
    }
  }
}
</style>
